import { render, staticRenderFns } from "./OctFormCol.vue?vue&type=template&id=b21f402a&scoped=true&"
import script from "./OctFormCol.vue?vue&type=script&lang=js&"
export * from "./OctFormCol.vue?vue&type=script&lang=js&"
import style0 from "./OctFormCol.vue?vue&type=style&index=0&id=b21f402a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21f402a",
  null
  
)

export default component.exports